import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'rosie-banned',
    templateUrl: './banned.component.html',
    styleUrls: ['./banned.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BannedComponent {

  constructor() { }

}